import { createElement } from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';

import { PrivateWrapper } from '~modules/auth/ui';
import { CabinetIndexPage } from '~pages/cabinet';
import { AdminIndexPage } from '~pages/cabinet/admin';
import { AdminLayout } from '~pages/cabinet/admin/admin-layout';
import { EditPage, ListPage } from '~pages/cabinet/admin/sections';
import { SettingsPage } from '~pages/cabinet/admin/settings';
import { UserPage } from '~pages/cabinet/admin/users';
import { CabinetLayout } from '~pages/cabinet/cabinet-layout';
import { ErrorsPage } from '~pages/cabinet/errors';
import { DeniedPage } from '~pages/denied';
import { DevicePage } from '~pages/device';
import { ManagerAddPage, ManagerEndPage, ManagerListPage } from '~pages/manager';
import { Page404 } from '~pages/page-404';
import { PinCodePage } from '~pages/pin-code';
import { SessionPage } from '~pages/session';
import { TabelRowsPage } from '~pages/tabel';
import { AttendancePage } from '~pages/tabel/attendance/attendance';
import { LimitsPage } from '~pages/tabel/limits/limits.page';
import { PeriodPage } from '~pages/tabel/period/period.page';
import { RolesPage } from '~pages/tabel/roles/roles.page';
import { RoundingPage } from '~pages/tabel/rounding/rounding.page';
import { Shifts } from '~pages/tabel/shifts/shifts.page';
import { TabelLayout } from '~pages/tabel/tabel-layout';
import { routerKeys } from '~shared/router';

import Layout from './layout';

export function AppRouter() {
	const browserRouter = createBrowserRouter([
		{
			element: createElement(Layout),
			children: [
				{
					path: routerKeys.device.byNumber(':number'),
					element: createElement(DevicePage),
				},
				{
					path: routerKeys.page404(),
					element: createElement(Page404),
				},
				{
					path: routerKeys.root(),
					element: <Navigate to={routerKeys.cabinet.root()} />,
				},
				{
					element: createElement(PrivateWrapper),
					children: [
						{
							path: routerKeys.denied(),
							element: createElement(DeniedPage),
						},
						{
							element: createElement(CabinetLayout),
							path: routerKeys.cabinet.root(),
							children: [
								{
									index: true,
									element: createElement(CabinetIndexPage),
								},
								{
									path: routerKeys.cabinet.errors.root(),
									element: createElement(ErrorsPage),
								},
								{
									element: createElement(AdminLayout),
									children: [
										{
											path: routerKeys.cabinet.admin.root(),
											children: [
												{
													path: routerKeys.cabinet.admin.root(),
													element: createElement(AdminIndexPage),
												},
												{
													path: routerKeys.cabinet.admin.sections.root(),
													element: createElement(ListPage),
												},
												{
													path: routerKeys.cabinet.admin.sections.section(':id'),
													element: createElement(EditPage),
												},
												{
													path: routerKeys.cabinet.admin.settings.root(),
													element: createElement(SettingsPage),
												},
												{
													path: routerKeys.cabinet.admin.users.root(),
													element: createElement(UserPage),
												},
											],
										},
									],
								},
							],
						},
						{
							path: routerKeys.session(),
							element: createElement(SessionPage),
						},
						{
							path: routerKeys.pinCodes(),
							element: createElement(PinCodePage),
						},
						{
							path: routerKeys.manager.root(),
							children: [
								{
									index: true,
									element: createElement(ManagerListPage),
								},
								{
									path: routerKeys.manager.add(),
									element: createElement(ManagerAddPage),
								},
								{
									path: routerKeys.manager.end(':id'),
									element: createElement(ManagerEndPage),
								},
							],
						},
						{
							path: routerKeys.tabel.root(),
							element: createElement(TabelLayout),
							children: [
								{
									index: true,
									element: createElement(TabelRowsPage),
								},
								{
									path: routerKeys.tabel.period(),
									element: createElement(PeriodPage),
								},
								{
									path: routerKeys.tabel.roles(),
									element: createElement(RolesPage),
								},
								{
									path: routerKeys.tabel.rounding(),
									element: createElement(RoundingPage),
								},
								{
									path: routerKeys.tabel.addUser(),
									element: createElement(Shifts),
								},
								{
									path: routerKeys.tabel.limits(),
									element: createElement(LimitsPage),
								},
								{
									path: routerKeys.tabel.attendance(),
									element: createElement(AttendancePage),
								},
								{
									path: `${routerKeys.tabel.attendance()}/:userId`,
									element: createElement(AttendancePage),
								},
							],
						},
					],
				},
			],
		},
	]);

	return <RouterProvider router={browserRouter} />;
}
